import { Helmet } from "react-helmet-async";
import AgendaPage from "../components/pages/dashboard/agenda/AgendaPage";

const Agenda = () => {
  return (
    <div className="agenda-page">
      <Helmet>
        <title>Agenda | Super User Manager</title>
        <meta
          name="description"
          content="Agenda: plan appointments with your team and your customers"
        />
        <link
          rel="canonical"
          href={`${process.env.REACT_APP_HOST_URL}/control-panel/agenda`}
        />
      </Helmet>
      <AgendaPage />
    </div>
  );
};

export default Agenda;
